import { Outlet, useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Layout = () => {

  const navigate = useNavigate(); 

  return (
    <div className="layout-container">
      <Header navigate={navigate} />
      <main>
        <Outlet/>
      </main>
      <Footer />
    </div>
  );
  
};

export default Layout;